import FaqSection from '@/v2/components/sections/common/faq-section'
import ForWhoSection from '@/v2/components/sections/common/for-who-section'
import HelperSection from '@/v2/components/sections/common/helper-section'
import PromotionalBannerSection from '@/v2/components/sections/common/promotional-banner-section'
import WhyWeSection from '@/v2/components/sections/common/why-we-section'
import HeroSection from '@/v2/components/sections/ski-gear-shipping/hero-section'

import {
  benefitsSectionContent,
  faqSectionContent,
  forWhoSectionContent,
  helperSectionContent,
  heroSectionContent,
  promotionalBannerSectionContent,
  whyWeSectionContent
} from '@/v2/constants/pages/public-pages/ski-gear-shipping-page'

interface SkiGearShippingPageProps {}

const SkiGearShippingPage: React.FC<SkiGearShippingPageProps> = () => {
  return (
    <>
      <HeroSection
        {...heroSectionContent}
        btnClassName='xl-min:!w-[279px] md-mn:w-[240px] w-[278px] xl-min:h-[60px] h-[44px]'
      />
      <WhyWeSection {...whyWeSectionContent} className='[&_article]:bg-transparent [&_article_img]:w-[100px]' />
      <ForWhoSection isBgDark {...forWhoSectionContent} />
      <HelperSection {...helperSectionContent} imgClassName='xl-min:w-[618px] xl-min:h-[387px] !w-[343px] !h-[215px]' />
      <ForWhoSection
        isBgDark
        {...benefitsSectionContent}
        className={`
          md-mn:[&_div_div]:!grid-cols-3
          [&_article]:flex-col
          [&_article]:text-center
          [&_ul]:list-none
          lg-mn:[&_ul]:px-0
          md-mn:[&_ul]:px-7
          [&_ul]:px-0
          [&_button]:!w-[278px]
          `}
        imgClassName='xl-min:!w-[362px] xl-min:!h-[239px] md-mn:w-[232px] md-mn:h-[154px] w-[315px] h-[208px]'
      />
      <PromotionalBannerSection
        card={promotionalBannerSectionContent}
        ctaButton={promotionalBannerSectionContent.ctaButton}
        imgClassName='xl-min:w-[675px] xl-min:h-[480px] w-[337px] h-[240px]'
        className={`
          md-mn:[&_article]:flex-row-reverse 
          xl-min:[&_article]:h-auto
          md-mn:[&_p]:!w-full
          [&_p]:w-[90%]
          lg-mn:[&_h3]:!w-full
          md-mn:[&_h3]:w-[90%]
          `}
      />
      <FaqSection isBgDark {...faqSectionContent} />
    </>
  )
}

export default SkiGearShippingPage
